// extracted by mini-css-extract-plugin
export default {"error":"QZ5v0GwPgH4GPYnbqLmh","compact":"TFq_Mfm2JSps4sLB49em"};